import { render, staticRenderFns } from "./autorizacionCos.vue?vue&type=template&id=6fcc3bdc"
import script from "./autorizacionCos.vue?vue&type=script&lang=js"
export * from "./autorizacionCos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports